// extracted by mini-css-extract-plugin
export default {"bounce":"J_c6","loading":"J_c7","logo-mark-bounce-right":"J_c8","logo-mark-bounce-left":"J_c9"};